<template>
  <fragment>
    <mc-app-header title="Edit Flow">
      <template #right>
        <div class="level-item">
          <b-button type="is-primary" @click="cloning = true">Clone</b-button>
        </div>
        <div class="level-item">
          <b-button
            :loading="flows.submitting"
            type="is-primary"
            @click="updateFlowHandler"
            >Update</b-button
          >
        </div>
        <div class="level-item">
          <b-dropdown :disabled="flows.publishing" position="is-bottom-left">
            <button slot="trigger" class="button is-primary">
              <span>Publish</span>
              <b-icon icon="menu-down" />
            </button>

            <b-dropdown-item @click="publishFlowHandler('admin')">
              <div class="media">
                <div class="media-content">
                  <div class="title is-6">For Admin</div>
                  <div class="content is-small">
                    Flow will only be published for admin users.
                  </div>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item @click="publishFlowHandler('user')">
              <div class="media">
                <div class="media-content">
                  <div class="title is-6">For Users</div>
                  <div class="content is-small">
                    The Flow will be published for all the users!! and this will
                    override the previous version of this flow.
                  </div>
                </div>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="edit-flow section">
        <b-loading v-if="flows.loadingSelected" active :is-full-page="false" />
        <mc-error-layout
          v-else-if="flows.selectError"
          message="Failed to load flows!"
          :retry-fn="() => selectFlow($route.params.id)"
        />
        <form v-else class="mc-container">
          <div class="edit-flow__group">
            <b-field>
              <b-input
                v-model="flows.selected.id"
                disabled
                icon="format-title"
                placeholder="Flow Name"
                type="text"
              />
            </b-field>
            <b-field class="edit-flow__switch">
              <b-switch v-model="flows.selected.public">
                <b>Public</b>
              </b-switch>
            </b-field>
          </div>
          <b-field label="Tag Flow">
            <b-taginput
              v-model="flows.selected.tags"
              allow-new
              autocomplete
              :data="tags"
              ellipsis
              icon="label"
              placeholder="Type in tag to add, and press Enter"
              @typing="searchTagsHandler"
            >
              <template #default="{ option }">
                {{ option }}
              </template>
            </b-taginput>
          </b-field>
          <flow-editor
            ref="flowEditor"
            :flow-definition="flows.selected.definition"
            split-view-height="calc(100vh - 280px)"
          />
        </form>
      </div>
      <clone-flow-modal
        :active="cloning"
        :flow-id="flows.selected.id"
        @close="cloning = false"
      />
    </mc-app-body>
  </fragment>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapActions, mapState } from 'vuex';

import CloneFlowModal from './CloneFlowModal';
import FlowEditor from '../../ui/chat/FlowEditor';

export default {
  data: function() {
    return {
      cloning: false,
      tags: []
    };
  },
  computed: {
    ...mapState(['flows'])
  },
  methods: {
    ...mapActions('flows', ['selectFlow', 'updateFlow', 'publishFlow']),
    getFlowObject() {
      const definition = this.$refs.flowEditor.getDefinition();
      return {
        id: this.flows.selected.id,
        public: this.flows.selected.public,
        tags: this.flows.selected.tags || [],
        definition
      };
    },
    async updateFlowHandler() {
      try {
        await this.updateFlow(this.getFlowObject());
        this.$buefy.toast.open({
          message: 'Flow updated successfully',
          type: 'is-success'
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to update flow!',
          type: 'is-danger'
        });
      }
    },
    async publishFlowHandler(mode) {
      try {
        await this.updateFlow(this.getFlowObject());
        await this.publishFlow({ flowId: this.flows.selected.id, mode });
        this.$buefy.toast.open({
          message: 'Flow published successfully',
          type: 'is-success'
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to publish flow!!',
          type: 'is-danger'
        });
      }
    },
    searchTagsHandler: debounce(function(search) {
      const index = this.$searchClient.initIndex('flows');
      index.searchForFacetValues(
        {
          facetName: 'tags',
          facetQuery: search,
          hitsPerPage: 5
        },
        (error, data) => {
          if (error) {
            this.$buefy.toast.open({
              message: 'Failed to search for flow tags!',
              type: 'is-danger'
            });
          } else {
            this.tags = data.facetHits.map(o => o.value);
          }
        }
      );
    }, 400)
  },
  components: {
    CloneFlowModal,
    FlowEditor
  },
  created() {
    this.selectFlow(this.$route.params.id);
  }
};
</script>

<style lang="scss" scoped>
.media-content {
  white-space: normal;
}

.edit-flow {
  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;

    .field {
      flex: 1 0 0;
      margin-bottom: 0;

      &:first-child {
        margin-right: 1rem;
      }
    }
  }

  &__switch {
    display: flex;
    flex-direction: column;
  }
}
</style>
